import React from "react";
import { Button } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { styled } from "@mui/material/styles";
import ExcelJS from "exceljs";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const LoadTemplateButton = ({ onTemplateLoaded, onError }) => {
  const inputId = "invoice-template-upload";

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Verify it's an Excel file
    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (fileExtension !== "xlsx") {
      onError("Please upload a valid Excel (.xlsx) template.");
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      const buffer = await file.arrayBuffer();
      await workbook.xlsx.load(buffer);

      // Pass the loaded workbook back to the parent state
      onTemplateLoaded(workbook);

      console.log("Template Loaded Successfully");
    } catch (err) {
      console.error(err);
      onError("Failed to load the Excel template.");
    }

    // Reset input so users can re-upload the same file if needed
    event.target.value = null;
  };

  return (
    <Button
      component="label"
      variant="outlined" // Distinct style from the 'Load Rates' button
      htmlFor={inputId}
      startIcon={<FileUploadIcon />}
    >
      Load Invoice Template
      <VisuallyHiddenInput
        id={inputId}
        type="file"
        onChange={handleFileChange}
        accept=".xlsx"
      />
    </Button>
  );
};

export default LoadTemplateButton;
